import { Button, Modal, message } from "antd";
import { useEffect, useState } from "react";
import config from "../../../config";
const base_url = config.base_url;
function DeleteSuperCodeModal({
  open,
  closeModal,
  deletedCoupon,
  setTableData,
  formateSuperCodeTableData,
}) {
  const [messageApi, contextHolder] = message.useMessage();
  const [deleteButtonLoading, setDeleteButtonLoading] = useState(false);
  const feedbackMessage = (type, message) => {
    messageApi.open({
      type: type,
      content: message,
    });
  };

  const handleDeleteCoupon = async () => {
    setDeleteButtonLoading(true);

    await fetch(base_url + "admin/supercodes/delete", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `code=${deletedCoupon}`,
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        feedbackMessage("success", "Code Deleted Successfully");
        setTableData(formateSuperCodeTableData(res));
        setDeleteButtonLoading(false);
      })
      .catch((err) => {
        console.log(err);
        feedbackMessage("error", "Error in deleting the code");
        setDeleteButtonLoading(false);
      });
    closeModal();
  };

  return (
    <Modal
      className="deleteModal"
      closeIcon={false}
      open={open}
      onCancel={(e) => {
        closeModal();
      }}
      footer={[
        <Button
          style={{
            width: "83px",
            height: "41px",
          }}
          key="cancel"
          onClick={() => {
            closeModal();
          }}
          className="cancelButton"
          disabled={deleteButtonLoading}
        >
          Cancel
        </Button>,
        <Button
          onClick={(e) => {
            handleDeleteCoupon();
          }}
          loading={deleteButtonLoading}
          key={"delete"}
          className="deletePartnerButton"
        >
          Delete
        </Button>,
      ]}
    >
      <div className="deleteModalContent">
        {" "}
        {contextHolder}
        <h3>Are You Sure You Want To Delete Code?</h3>
      </div>
    </Modal>
  );
}
export default DeleteSuperCodeModal;
